import { RESET_ERROR_FIELD } from './types'

export const resetError = field => ({
  type: RESET_ERROR_FIELD,
  field,
})
